import "./menu.scss"

export default function Menu({ menuOpen, setMenuOpen }) {
  return (
    <div className={ "menu " + (menuOpen && "active") } onClick={() => setMenuOpen(false)}>
        <ul>
            <li><a href="#intro">Home</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#works">Skills</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact</a></li>
        </ul>    
        <a href="\assets\Resume_Flynn_2022.pdf" style={{position: "absolute", bottom: "5%"}} target="_blank" rel="noreferrer" className="button" alt="Download Resume">Download Resume</a>

    </div>
  )
}
